import { useNavigate } from 'react-router-dom';
import { Icon } from '@/ui/icons/Icon';
import { useQuestionnaire } from '../../hooks/useQuestionnaire';
import { routes } from '@/routes/routes';
import type { DesiredAmountOption } from '../../types/questionnaire';
import styles from './DesiredAmountPage.module.scss';

const OPTIONS: { value: DesiredAmountOption; label: string; showArrow: boolean }[] = [
  { value: '1000', label: '1 000 lei', showArrow: true },
  { value: '5000', label: '5 000 lei', showArrow: true },
  { value: '12000', label: '12 000 lei', showArrow: true },
  { value: 'other', label: 'Altă sumă', showArrow: false },
];

function DesiredAmountPage() {
  const navigate = useNavigate();
  const { saveDesiredAmount, isSavingDesiredAmount } = useQuestionnaire();

  const handleSelect = async (value: DesiredAmountOption) => {
    await saveDesiredAmount(value);
    navigate(routes.questionnaire.base);
  };

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h1 className={styles.title}>
          Cam ce sumă{'\n'}ai în vedere?
        </h1>
      </div>

      <div className={styles.options}>
        {OPTIONS.map(({ value, label, showArrow }) => (
          <button
            key={value}
            className={styles.option}
            disabled={isSavingDesiredAmount}
            onClick={() => handleSelect(value)}
          >
            <span className={styles.optionText}>{label}</span>
            {showArrow && (
              <span className={styles.optionArrow}>
                <Icon name="arrow-right" size={24} />
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}

export default DesiredAmountPage;
